export const BILLING_DETAILS_REQUIRED_COUNTRIES = ['BE'];

export const isBillingDetailsRequired = (quotation) => {
    if (!quotation) return false;
    const countryCode = (
        quotation.customer?.country?.code ||
        quotation.billing_address?.country?.code ||
        quotation.address?.country?.code ||
        ''
    ).toUpperCase();
    const isCompany = quotation.customer?.organisation_type !== 'private';
    return BILLING_DETAILS_REQUIRED_COUNTRIES.includes(countryCode) && isCompany;
};
